import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HomePage() {
  return <div className="w-full bg-white" data-id="element-612">
      {/* Hero Section */}
      <section className="w-full bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-613">
        <div className="container mx-auto px-4 py-20" data-id="element-614">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-615">
            <div className="md:w-1/2" data-id="element-616">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-617">
                Hello, I'm Azn Shawn Alahah
              </h1>
              <p className="text-xl text-gray-700 mb-8" data-id="element-618">
                Writer, creator, and entrepreneur exploring the intersections of
                culture, technology, and creativity.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-619">
                <Link to="/about" className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors" data-id="element-620">
                  Learn more about me
                </Link>
                <Link to="/contact" className="px-6 py-3 bg-white text-blue-600 font-medium rounded-lg border border-blue-600 hover:bg-blue-50 transition-colors" data-id="element-621">
                  Get in touch
                </Link>
              </div>
            </div>
            <div className="md:w-1/2 mt-8 md:mt-0" data-id="element-622">
              <div className="max-w-sm mx-auto" data-id="element-623">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8vYnR9BQ9MsBmxwsWop4YK/Generated_Image_September_17%2C_2025_-_8_12PM~2.png" alt="Azn Shawn Alahah in a professional navy suit" className="w-full h-auto rounded-lg shadow-lg" data-id="element-624" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Featured Sections */}
      <section className="container mx-auto px-4 py-16" data-id="element-625">
        <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-626">Featured Work</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-627">
          {/* Media */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-628">
            <div className="flex items-center justify-center h-48 bg-gray-50" data-id="element-629">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bYMJMVLsDEX7X1xfNoeztq/ChatGPT_Image_Oct_7%2C_2025%2C_08_44_23_PM.png" alt="Media icon" className="h-32 w-32 object-contain" data-id="element-630" />
            </div>
            <div className="p-6" data-id="element-631">
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-632">
                Media
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-633">
                Explore my podcasts, videos, and other media projects.
              </p>
              <Link to="/media" className="inline-flex items-center text-blue-600 font-medium" data-id="element-634">
                View media <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-635" />
              </Link>
            </div>
          </div>
          {/* Writing */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-636">
            <div className="flex items-center justify-center h-48 bg-gray-50" data-id="element-637">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rNqr3NvZqMTYZrtK8YhsTh/ChatGPT_Image_Oct_7%2C_2025%2C_08_36_19_PM.png" alt="Writing icon" className="h-32 w-32 object-contain" data-id="element-638" />
            </div>
            <div className="p-6" data-id="element-639">
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-640">
                Writing
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-641">
                Read my articles, essays, and other written work.
              </p>
              <Link to="/writing" className="inline-flex items-center text-blue-600 font-medium" data-id="element-642">
                Read my writing <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-643" />
              </Link>
            </div>
          </div>
          {/* Ventures */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-644">
            <div className="flex items-center justify-center h-48 bg-gray-50" data-id="element-645">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fAiKNJKxfWJNsH7JkAs2iD/rocket_icon_transparent.png" alt="Ventures icon" className="h-32 w-32 object-contain" data-id="element-646" />
            </div>
            <div className="p-6" data-id="element-647">
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-648">
                Ventures
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-649">
                Discover my entrepreneurial projects and business ventures.
              </p>
              <Link to="/ventures" className="inline-flex items-center text-blue-600 font-medium" data-id="element-650">
                Explore ventures <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-651" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}